module.exports = __webpack_public_path__ + "static/media/validBarcode.876c264f.png";